import React from 'react';

interface Props {
  score: number;    // 0–5
  max?: number;
  label?: string;
  showValue?: boolean;
  size?: 'sm' | 'md' | 'lg';
}

const colorFor = (pct: number) => {
  if (pct >= 0.8) return 'bg-brand-success';
  if (pct >= 0.6) return 'bg-brand-accent';
  if (pct >= 0.4) return 'bg-brand-warning';
  return 'bg-brand-error';
};

const ScoreBar: React.FC<Props> = ({ score, max = 5, label, showValue = true, size = 'md' }) => {
  const pct = Math.min(Math.max(score / max, 0), 1);
  const heights: Record<string, string> = { sm: 'h-1.5', md: 'h-2.5', lg: 'h-4' };

  return (
    <div className="w-full">
      {(label || showValue) && (
        <div className="flex justify-between mb-1">
          {label && <span className="text-xs text-gray-500">{label}</span>}
          {showValue && (
            <span className="text-xs font-semibold text-gray-900 ml-auto">
              {score.toFixed(2)} / {max}
            </span>
          )}
        </div>
      )}
      <div className={`w-full bg-gray-200 rounded-full overflow-hidden ${heights[size]}`}>
        <div
          className={`${heights[size]} rounded-full transition-all duration-500 ${colorFor(pct)}`}
          style={{ width: `${pct * 100}%` }}
        />
      </div>
    </div>
  );
};

export default ScoreBar;
